import axios from "axios";
import Vue from "vue";
import moment from 'vue-moment';
import Vuex from "vuex";

import createPersistedState from 'vuex-persistedstate';

import { deliverableChat } from "./modules/chat";
import { projectChat } from "./modules/chat";

import { deliverables } from "./modules/deliverables";
import { relatedDeliverables } from "./modules/deliverables";
import { relatedDeliverablesCalendar } from "./modules/deliverables";

import { deliverableTemplates } from "./modules/deliverableTemplates";

import { colorThemeVariables } from "./modules/colorThemeVariables";

Vue.use(Vuex);
Vue.use(moment)

Vue.set(deliverables.state, '_namespace', "");
Vue.set(relatedDeliverables.state, '_namespace', "relatedDeliverables/");
Vue.set(relatedDeliverablesCalendar.state, '_namespace', "relatedDeliverablesCalendar/");

Vue.set(deliverableTemplates.state, '_namespace', "deliverableTemplates/");

// --- Duplication helpers ---


export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: 'CSM_FILTER_STATE',
            paths: [
                'deliverables.deliverableFilter', 
                'deliverables.myWeekDeliverableFilter', 
                'deliverables.mediaCallFilter',
                'deliverables.globalSearchFilter', 
                'deliverables.GSRecentSearch',
                'deliverables.userViews', 
                'deliverables.projectFilter', 
                'deliverables.myProjectFilter',
                'deliverables.calendarFilter',
                'deliverables.projectSort',
                'deliverables.myProjectSort',
                'deliverables.socialMediaFilter',
                'deliverables.socialMediaCalendarFilter',
            ],
        }),
        createPersistedState({
            key: 'CSM_SORTING_OPTIONS',
            paths: [
                'deliverables.storedSortKey',
                'deliverables.storedSortState',
                'deliverables.storedSortFieldId',
                'deliverables.storedTaskFieldsOrder',
                'deliverables.storedTaskOrder',
                'deliverables.nextSortState',
                'deliverableTemplates.storedSortKey',
                'deliverableTemplates.storedSortState',
                'deliverableTemplates.storedSortFieldId',
                'deliverableTemplates.storedTaskFieldsOrder',
                'deliverableTemplates.storedTaskOrder',
                'deliverableTemplates.nextSortState',
            ]
        })
    ],
    modules: {
        deliverables: deliverables
        ,relatedDeliverables: relatedDeliverables
        ,relatedDeliverablesCalendar: relatedDeliverablesCalendar
        ,deliverableTemplates: deliverableTemplates
        ,colorThemeVariables: colorThemeVariables
        ,deliverableChat
        ,projectChat
    },
    state: {
        token: localStorage.getItem("token") || "",
        user: "",
        status: "",
        userAbilities: localStorage.getItem("userAbilities") ? JSON.parse(localStorage.getItem("userAbilities")) : "",
        duplicationWizard: {
            step: 1,
            sourceProject: null,
            projectOptions: {
                title: '',
                department: true,
                deadline: true,
                projectDetail: true,
                resources: true,
                engagementManager: true,
                projectLead: true,
                status: true,
                audience: true,
                budget: true,
                requisitionNumber: true,
                deliverables: true,
                taskUsers: true,
                taskNotes: true,
                taskDueDates: false,
                deliverableDueDates: true,
                socialMediaPosts: true,
            },
            selectedDeliverableIds: [],
            selectedSocialMediaPostIds: {},
            selectedSocialMediaPostCounts: {},
            allDeliverableIds: [],
            allDeliverablesLoaded: false,
            allDeliverables: [],
            duplicationStarted: false,
        },
    },
    mutations: {
    	// bindNamespace(_, {module, namespace}) {
        //  	Vue.set(module.state, '_namespace', namespace);
    	// },
        auth_request(state) {
            state.state = "loading";
        },
        auth_error(state) {
            state.state = "error";
        },
        auth_success(state, data) {
            state.status = "success";
            state.token = data.token;
            state.userAbilities = data.userAbilities;
        },
        setDefaultSort(state) {
            const storedSortKey = localStorage.getItem('storedSortKey')
            if(storedSortKey === null) {
                localStorage.setItem('storedSortState', 'ASC')
                localStorage.setItem('nextSortState', 'DESC')
                localStorage.setItem('storedSortKey', 'created_date')
                state.storedSortKey = 'created_date'
                state.nextSortState = 'DESC'
                state.storedSortState = 'ASC'
            } 
        },
        logout(state) {
            state.status = "";
            state.token = "";
            state.user = null;
        },
        SET_DUPLICATION_STEP(state, step) {
            state.duplicationWizard.step = step;
        },
        SET_DUPLICATION_SOURCE_PROJECT(state, project) {
            state.duplicationWizard.sourceProject = project;
        },
        SET_DUPLICATION_PROJECT_OPTIONS(state, options) {
            state.duplicationWizard.projectOptions = { ...state.duplicationWizard.projectOptions, ...options };
        },
        SET_DUPLICATION_TITLE(state, title) {
            state.duplicationWizard.projectOptions.title = title;
        },
        SET_ALL_DELIVERABLE_IDS(state, { ids, deliverables }) {
            state.duplicationWizard.allDeliverableIds = ids;
            state.duplicationWizard.allDeliverables = deliverables || [];
            state.duplicationWizard.allDeliverablesLoaded = true;
        },
        SET_DUPLICATION_SOCIAL_POSTS(state, { parentDeliverableId, posts, posts_count, posts_loaded }) {
            const normalizedParentId = parseInt(parentDeliverableId, 10);
            const deliverable = state.duplicationWizard.allDeliverables.find(d => parseInt(d.id, 10) === normalizedParentId);
            if (!deliverable) return;

            const loadedPosts = Array.isArray(posts) ? posts : [];
            Vue.set(deliverable, 'posts', loadedPosts);
            Vue.set(deliverable, 'posts_count', typeof posts_count === 'number' ? posts_count : loadedPosts.length);
            Vue.set(deliverable, 'posts_loaded', posts_loaded !== false);

            const hasExistingSelection = Object.prototype.hasOwnProperty.call(
                state.duplicationWizard.selectedSocialMediaPostIds,
                normalizedParentId
            );

            if (
                state.duplicationWizard.selectedDeliverableIds.some(id => parseInt(id, 10) === normalizedParentId) &&
                !hasExistingSelection
            ) {
                Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, normalizedParentId, loadedPosts.map(p => p.id));
            }
        },
        TOGGLE_DELIVERABLE(state, deliverableId) {
            const idx = state.duplicationWizard.selectedDeliverableIds.indexOf(deliverableId);
            if (idx === -1) {
                state.duplicationWizard.selectedDeliverableIds.push(deliverableId);
                const deliverable = state.duplicationWizard.allDeliverables.find(d => d.id === deliverableId);
                // Auto-select all posts when selecting an organic social media deliverable
                if (deliverable && deliverable.posts && deliverable.posts.length > 0) {
                    Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, deliverableId, deliverable.posts.map(p => p.id));
                }
            } else {
                state.duplicationWizard.selectedDeliverableIds.splice(idx, 1);
                Vue.delete(state.duplicationWizard.selectedSocialMediaPostIds, deliverableId);
                Vue.delete(state.duplicationWizard.selectedSocialMediaPostCounts, deliverableId);
            }
        },
        SELECT_ALL_DELIVERABLES(state) {
            state.duplicationWizard.selectedDeliverableIds = [...state.duplicationWizard.allDeliverableIds];
            // Auto-select all tasks and posts for all deliverables
            state.duplicationWizard.allDeliverables.forEach(d => {
                if (d.posts && d.posts.length > 0) {
                    Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, d.id, d.posts.map(p => p.id));
                }
            });
        },
        CLEAR_ALL_DELIVERABLES(state) {
            state.duplicationWizard.selectedDeliverableIds = [];
            state.duplicationWizard.selectedSocialMediaPostIds = {};
            state.duplicationWizard.selectedSocialMediaPostCounts = {};
        },
        SELECT_ALL_SOCIAL_POSTS(state, parentDeliverableId) {
            const deliverable = state.duplicationWizard.allDeliverables.find(d => d.id === parentDeliverableId);
            if (deliverable && deliverable.posts) {
                Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, parentDeliverableId, deliverable.posts.map(p => p.id));
            }
        },
        CLEAR_ALL_SOCIAL_POSTS(state, parentDeliverableId) {
            Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, parentDeliverableId, []);
            Vue.set(state.duplicationWizard.selectedSocialMediaPostCounts, parentDeliverableId, {});
        },
        SET_SOCIAL_MEDIA_POST_IDS(state, { parentDeliverableId, postIds }) {
            Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, parentDeliverableId, postIds);
            if (Array.isArray(postIds) && postIds.length > 0 && !state.duplicationWizard.selectedDeliverableIds.includes(parentDeliverableId)) {
                state.duplicationWizard.selectedDeliverableIds.push(parentDeliverableId);
            }
        },
        SET_SOCIAL_MEDIA_POST_COUNT(state, { parentDeliverableId, seriesMasterId, count }) {
            if (!state.duplicationWizard.selectedSocialMediaPostCounts[parentDeliverableId]) {
                Vue.set(state.duplicationWizard.selectedSocialMediaPostCounts, parentDeliverableId, {});
            }
            Vue.set(state.duplicationWizard.selectedSocialMediaPostCounts[parentDeliverableId], seriesMasterId, count);
        },
        CLEAR_SOCIAL_MEDIA_POST_COUNTS(state, parentDeliverableId) {
            Vue.set(state.duplicationWizard.selectedSocialMediaPostCounts, parentDeliverableId, {});
        },
        TOGGLE_SOCIAL_MEDIA_POST(state, { parentDeliverableId, postId }) {
            if (!state.duplicationWizard.selectedSocialMediaPostIds[parentDeliverableId]) {
                Vue.set(state.duplicationWizard.selectedSocialMediaPostIds, parentDeliverableId, []);
            }
            const arr = state.duplicationWizard.selectedSocialMediaPostIds[parentDeliverableId];
            const idx = arr.indexOf(postId);
            if (idx === -1) {
                arr.push(postId);
                if (!state.duplicationWizard.selectedDeliverableIds.includes(parentDeliverableId)) {
                    state.duplicationWizard.selectedDeliverableIds.push(parentDeliverableId);
                }
            } else {
                arr.splice(idx, 1);
            }
        },
        SET_DUPLICATION_STARTED(state, started) {
            state.duplicationWizard.duplicationStarted = started;
        },
        RESET_DUPLICATION_WIZARD(state) {
            state.duplicationWizard.step = 1;
            state.duplicationWizard.sourceProject = null;
            state.duplicationWizard.projectOptions = {
                title: '',
                department: true,
                deadline: true,
                projectDetail: true,
                resources: true,
                engagementManager: true,
                projectLead: true,
                status: true,
                audience: true,
                budget: true,
                requisitionNumber: true,
                deliverables: true,
                taskUsers: true,
                taskNotes: true,
                taskDueDates: false,
                deliverableDueDates: true,
                socialMediaPosts: true,
            };
            state.duplicationWizard.selectedDeliverableIds = [];
            state.duplicationWizard.selectedSocialMediaPostIds = {};
            state.duplicationWizard.selectedSocialMediaPostCounts = {};
            state.duplicationWizard.allDeliverableIds = [];
            state.duplicationWizard.allDeliverablesLoaded = false;
            state.duplicationWizard.allDeliverables = [];
            state.duplicationWizard.duplicationStarted = false;
        },
    },
    actions: {
    	// bindNamespaces({commit}, {_modulesNamespaceMap}) {
        //   Object.entries(_modulesNamespaceMap).forEach(([namespace, module]) => {
        //       commit('bindNamespace', {module, namespace});
        //   });
    	// },
        login({ commit }, loginData) {
            return new Promise((resolve, reject) => {
                commit("auth_request");
                axios
                    .post(process.env.MIX_API_BASE_URL + "login", loginData)
                    .then(response => {
                        const token = response.data.token;
                        localStorage.setItem("token", token);
                        localStorage.setItem("user", response.data.user.name);
                        localStorage.setItem("userId", response.data.user.id);
                        localStorage.setItem("userAbilities", JSON.stringify(response.data.userAbilities));
                        axios.defaults.headers.common["Authorization"] =
                            "Bearer " + token;
                        commit("auth_success", response.data);
                        commit("setDefaultSort");

                        // set token cookie
                        const d = new Date();
                        d.setTime(d.getTime() + 24*3600*1000);
                        document.cookie = `auth_token=${token};expires=${d.toUTCString()};path=/`;

                        resolve(response);
                    })
                    .catch(err => {
                        commit("auth_error");
                        localStorage.removeItem("token");
                        
                        // clear token cookie
                        document.cookie = "auth_token=;path=/";

                        reject(err);
                    });
            });
        },
        async sendResetPasswordEmail({ commit }, payload) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "sendResetPasswordEmail",
                payload
            )
            return response
        },
        async resetPassword({ commit }, payload) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "resetPassword",
                payload
            )
            return response
        },
        async register({}, registerData) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + "register",
                registerData
            );
            return response;
        },
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit("logout");
                localStorage.removeItem("dashboardActiveSave");
                localStorage.removeItem("myWeekActiveSave");
                localStorage.removeItem("mediaCallActiveSave");
                localStorage.removeItem("dashboardActiveSaveTitle");
                localStorage.removeItem("myWeekActiveSaveTitle");
			    localStorage.removeItem("mediaCallActiveSaveTitle");
                localStorage.removeItem("currentFilterData");
                localStorage.removeItem("dashboardActiveSaveData");
                localStorage.removeItem("myWeekActiveSaveData");
                localStorage.removeItem("mediaCallActiveSaveData");
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                localStorage.removeItem("userId");
                localStorage.removeItem("CSM_FILTER_STATE");
                localStorage.removeItem("userAbilities");
                delete axios.defaults.headers.common["Authorization"];
                // clear token cookie
                document.cookie = "auth_token=;path=/";
                location.reload()
                resolve();
            });
        },
        
        // For download files
        setUserAuthCookie({ getters }) {
            // set token cookie
            const d = new Date();
            d.setTime(d.getTime() + 24*3600*1000);
            document.cookie = `auth_token=${getters.authToken};expires=${d.toUTCString()};path=/`;
        },

        setLoginInformation({ commit }, r) {
            const token = r.data.token;
            localStorage.setItem("token", token);
            localStorage.setItem("user", r.data.user.name);
            localStorage.setItem("userId", r.data.user.id);
            localStorage.setItem("userAbilities", JSON.stringify(r.data.userAbilities));
            axios.defaults.headers.common["Authorization"] =
                "Bearer " + token;
            commit("auth_success", r.data);
            commit("setDefaultSort");

            // set token cookie
            const d = new Date();
            d.setTime(d.getTime() + 24*3600*1000);
            document.cookie = `auth_token=${token};expires=${d.toUTCString()};path=/`;

            return r;
        },
        async initDuplicationWizard({ commit, dispatch }, projectId) {
            commit('RESET_DUPLICATION_WIZARD');
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + 'getProjectDeliverable/' + projectId
            );
            // Deep clone to avoid mutating the original source project object
            // (Vue 2 props are passed by reference; child components mutate via v-model)
            const projectDetail = JSON.parse(JSON.stringify(response.data.projectDetail));

            // Default deadline to No Date
            projectDetail.due_date = null;

            // Default status to "Not Started"
            if (Array.isArray(projectDetail.customFields)) {
                const statusField = projectDetail.customFields.find(
                    f => f.field_key === 'status' || f.field_id == 31
                );
                if (statusField && statusField.value_set) {
                    try {
                        const opts = typeof statusField.value_set === 'string'
                            ? JSON.parse(statusField.value_set)
                            : statusField.value_set;
                        if (Array.isArray(opts)) {
                            const notStarted = opts.find(
                                o => o && o.name && o.name.toLowerCase().replace(/\s+/g, '') === 'notstarted'
                            );
                            if (notStarted) {
                                statusField.value = notStarted;
                            }
                        }
                    } catch (e) {}
                }
            }

            commit('SET_DUPLICATION_SOURCE_PROJECT', projectDetail);

            // Use the original title as-is
            commit('SET_DUPLICATION_TITLE', projectDetail.title + ' (copy)');

            // Fetch all projects for duplicate-name warning UI in step 1
            const projectsResponse = await axios.get(
                process.env.MIX_API_BASE_URL + 'getAllProjects'
            );
            const allProjects = projectsResponse.data.allProjects || [];

            return { response, allProjects };
        },
        async fetchAllDeliverableIdsForDuplication({ commit }, projectId) {
            const response = await axios.get(
                process.env.MIX_API_BASE_URL + 'getProjectDeliverablesForDuplication/' + projectId
            );
            commit('SET_ALL_DELIVERABLE_IDS', {
                ids: response.data.deliverableIds,
                deliverables: response.data.deliverables,
            });
            return response.data;
        },
        async fetchDuplicationSocialPosts({ commit }, parentDeliverableId) {
            const response = await axios.get(
                process.env.MIX_API_BASE_URL + 'getDuplicationSocialPosts/' + parentDeliverableId
            );

            commit('SET_DUPLICATION_SOCIAL_POSTS', {
                parentDeliverableId,
                posts: response.data.posts,
                posts_count: response.data.posts_count,
                posts_loaded: response.data.posts_loaded,
            });

            return response.data;
        },
        async fetchDuplicationSocialPostsBatch({ commit }, parentDeliverableIds) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + 'getDuplicationSocialPosts',
                { parentDeliverableIds }
            );

            const deliverables = response.data.deliverables || {};
            Object.keys(deliverables).forEach(parentDeliverableId => {
                commit('SET_DUPLICATION_SOCIAL_POSTS', {
                    parentDeliverableId,
                    posts: deliverables[parentDeliverableId].posts,
                    posts_count: deliverables[parentDeliverableId].posts_count,
                    posts_loaded: deliverables[parentDeliverableId].posts_loaded,
                });
            });

            return response.data;
        },
        async submitDuplication({ commit }, payload) {
            const response = await axios.post(
                process.env.MIX_API_BASE_URL + 'duplicateProjectSelective',
                payload
            );
            return response;
        },
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authToken: state => state.token,
        userAbilities: state => state.userAbilities,
        duplicationWizard: state => state.duplicationWizard,
        selectedDeliverableCount: state => state.duplicationWizard.selectedDeliverableIds.length,
        isDeliverableSelected: state => id => state.duplicationWizard.selectedDeliverableIds.includes(id),
        selectedSocialPostCount: state => parentId => {
            const posts = state.duplicationWizard.selectedSocialMediaPostIds[parentId];
            return posts ? posts.length : 0;
        },
        isSocialPostSelected: state => (parentId, postId) => {
            const posts = state.duplicationWizard.selectedSocialMediaPostIds[parentId];
            return posts ? posts.includes(postId) : false;
        },
        totalSocialPostCount: state => parentId => {
            const deliverable = state.duplicationWizard.allDeliverables.find(d => d.id === parentId);
            return deliverable && deliverable.posts ? deliverable.posts.length : 0;
        },

    }
});
